module.exports = __webpack_public_path__ + "img/mated-photo.ac58dbf.png";